exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3 {\n    font-size: 24px;\n}\n.stat-info-wrapper {\n    position: relative;\n    width: 100%;\n}\n.full-width {\n    width: 100%;\n}\n.option-wrapper, .option-wrapper .v-radio, .option-wrapper .v-label, .option-wrapper .v-input__control {\n    width: 100%;\n}\n.flexcard {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n", ""]);

// exports
